import React from 'react';
import Bundle from './loadable';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import './App.css';
const Layout = Bundle(()=>import('./component/layout/layout'))
const Login= Bundle(()=>import('./page/login/login'));
const Home= Bundle(()=>import('./page/home/home'));
const System= Bundle(()=>import('./page/system/system'));
const User = Bundle(()=>import('./page/user/user'));
const Developer = Bundle(()=>import( './page/developer/developer'));
const Role = Bundle(()=>import('./page/role/role'));
const Roleuser = Bundle(()=>import('./page/userRole/userRole'))
const Menu = Bundle(()=>import('./page/menu/menu'));
const Log = Bundle(()=>import('./page/log/log'));
const Organize = Bundle(()=>import('./page/organize/organize'))
function App() {
  return (
    <div className="App">
        <Router>
            <Switch>
                <Route exact path='/' component={Login}/>
                <Route>
                    <Layout>
                        <Switch>
                            {/* <Route path="/home" component={Home}></Route> */}
                            <Route exact path="/sso/system" component={System}></Route>
                            <Route exact exact path="/sso/user" component={User}></Route>
                            <Route exact path="/sso/user/role" component={Roleuser}></Route>
                            <Route exact path="/backend/developer" component={Developer}></Route>
                            <Route exact path="/sso/role" component={Role}></Route>
                            <Route exact path="/sso/resource" component={Menu}></Route>
                            <Route exact path="/sso/log" component={Log}></Route>
                            <Route exact path="/backend/organization" component={Organize}></Route>
                            {/* <Route component={i404}></Route> */}
                        </Switch>
                    </Layout>
                </Route>
            </Switch>
        </Router>
    </div>
  );
}

export default App;
